import { useEffect, useState } from "react";
import { useOverlayScale, usePageScale } from "../editor/hooks";
import { cn } from "@acdc2/ui/lib/utils";

type Props = {
  size: number;
  dimension: "x" | "y";
  onChange: (newSize: number) => void;
};

export function TableResizer({ size, dimension, onChange }: Props) {
  const pageScale = usePageScale();
  const overlayScale = useOverlayScale();
  const handleSize = 8 / overlayScale;
  const [mouseDown, setMouseDown] = useState(false);

  const onMouseDown = () => {
    setMouseDown(true);
  };

  const onMouseMove = (e: MouseEvent) => {
    if (mouseDown) {
      const movement = dimension === "x" ? e.movementX : e.movementY;
      const scaledMovement = movement / pageScale;
      onChange(size + scaledMovement);
    }
  };

  const onMouseUp = () => {
    setMouseDown(false);
  };

  useEffect(() => {
    document.addEventListener("mousemove", onMouseMove);
    return () => document.removeEventListener("mousemove", onMouseMove);
  });

  useEffect(() => {
    document.addEventListener("mouseup", onMouseUp);
    return () => document.removeEventListener("mouseup", onMouseUp);
  });

  return (
    <div
      className="table-editor-table-resizer"
      style={{
        width: dimension === "x" ? `${size}px` : undefined,
        height: dimension === "y" ? `${size}px` : undefined,
      }}
    >
      <div
        className={cn("table-editor-table-resizer-handle", {
          "table-editor-table-resizer-handle-x": dimension === "x",
          "table-editor-table-resizer-handle-y": dimension === "y",
          resizing: mouseDown,
        })}
        style={{
          width: dimension === "x" ? `${handleSize}px` : undefined,
          height: dimension === "y" ? `${handleSize}px` : undefined,
        }}
        onMouseDown={onMouseDown}
      ></div>
    </div>
  );
}
